import { useMemo } from 'react';
import { useCanvasLayers } from '../stores/CanvasContext';

export function useLockedLayerIds(): Set<string> {
  const layers = useCanvasLayers();
  return useMemo(() => {
    const set = new Set<string>();
    for (const layer of layers) {
      if (layer.locked) set.add(layer.id);
    }
    return set;
  }, [layers]);
}
